import gql from 'graphql-tag';

export const deleteMonLogEntry = gql`
  mutation deleteMonLogEntry($id: String) {
    deleteMonLogEntry(id: $id) {
      value
    }
  }
`;
